module.exports = __webpack_public_path__ + "static/media/clock.e670b88a.svg";